export enum DesiredExposure {
  PrivateExcludedFromEDS = -1,
  Private = 0,
  Internal = 1,
  Public = 2,
  PublicSummaryOnly = 3,
}
